<template>
  <NiceView
    :aboveTitle="generalStore.viewHeader"
    :title="CommonService.routes.EVENTS.title"
    :icon="CommonService.routes.EVENTS.icon"
    :loading="loading"
    flexBody
  >
    <!-- Filters -->
    <NiceFilters v-model="filtersList" @change="filterChanged" :showCreateButton="permissions.can_create_events" />

    <!-- Table -->
    <NiceTable
      :actions="actions"
      :columns="columns"
      :data="data"
      :loading="loading"
      freezeLastColumn
      showFooter
      showLimit
      paginated
      @filterChange="filterChanged"
    />

    <!-- Form -->
    <NicePanel :name="panelName" @close="closeEdit">
      <EventForm @cancel="closeEdit" @success="successEdit" :data="selectedItem"></EventForm>
    </NicePanel>

    <!-- <pre>{{ data }}</pre> -->
  </NiceView>
</template>

<script setup>
import { ref, computed, inject, watch, onMounted } from "vue";
import { formatDateWithTime } from "@/plugins/date";
const $getQuery = inject("getQuery");
const $nice = inject("nice");

import { useRoute, useRouter } from "vue-router";
const route = useRoute();
const router = useRouter();

import { useGettext } from "vue3-gettext";
const { $gettext } = useGettext();

import CommonService from "@/services/common.service";
import ErrorService from "@/services/error.service";
import ApiService from "@/services/api/api.service";
import EventForm from "@/components/forms/EventForm.vue";

import { useGeneralStore } from "@/store/general.store";
const generalStore = useGeneralStore();
const permissions = computed(() => generalStore.permissions);
const modules = computed(() => generalStore.modules);

const data = ref([]);
const loading = ref(false);
const selectedItem = ref(null);
const panelName = "event";

// Watch for id change
watch(
  () => route.query,
  () => {
    if (route.query.id) {
      $nice.panel(panelName, true);
    }
  }
);

watch(
  () => route.params,
  (oldValue, newValue) => {
    if (oldValue.organizationId != newValue.organizationId) getData();
  }
);

onMounted(async () => {
  if (route.query.id) {
    $nice.panel(panelName, true);
  }
});

function closeEdit() {
  selectedItem.value = null;
  router.push({ query: { ...route.query, id: undefined } });
  $nice.panel(panelName, false);
}

function successEdit() {
  closeEdit();
  getData();
}

function openEvent(item) {
  router.push({
    name: "app.organizations.events.single",
    params: { organizationId: route.params.organizationId, eventId: item.id },
  });
}

function openEdit(item) {
  selectedItem.value = item;
  router.push({ query: { ...route.query, id: item.id } });
}

async function getData() {
  loading.value = true;
  try {
    const query = await $getQuery();
    data.value = await ApiService.events.getAll(route.params.organizationId, query);
  } catch (e) {
    ErrorService.showError(e);
  } finally {
    loading.value = false;
  }
}

const filtersList = [];

function filterChanged() {
  getData();
}

const actions = [
  {
    icon: () => "icon-edit-3",
    function: (v) => openEdit(v),
    disabled: () => !permissions.value.can_edit_events,
  },
  {
    icon: () => "icon-arrow-right",
    function: (v) => openEvent(v),
  },
];

const columns = [
  {
    name: $gettext("Name"),
    key: "name",
    hasOrder: true,
  },
  // {
  //   name: $gettext("Cover photo"),
  //   key: "cover_photo",
  // },
  {
    name: $gettext("Ticketing integration event ID"),
    key: "ticketing_integration_event_id",
    disabled: !modules.value.TICKETING_INTEGRATION,
    hasOrder: true,
  },
  {
    name: $gettext("Start time"),
    key: "start_time",
    class: "text-right",
    formatter: (v) => formatDateWithTime(v),
    hasOrder: true,
  },
  {
    name: $gettext("End time"),
    key: "end_time",
    class: "text-right",
    formatter: (v) => formatDateWithTime(v),
    hasOrder: true,
  },
];
</script>
